var render = function () {
var this$1 = this;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box"},[_c('img',{staticClass:"back",attrs:{"src":require("../assets/back.png"),"alt":""},on:{"click":function () { return this$1.$router.go(-1); }}}),_c('img',{staticClass:"table",attrs:{"src":require("../assets/table.png"),"alt":""}})])}
var staticRenderFns = []

export { render, staticRenderFns }